import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/mixpanel';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page name from pathname
    const pageName = location.pathname === '/' ? 'Home' : location.pathname.slice(1).replace(/-/g, ' ').replace(/\//g, ' > ');
    
    trackPageView(pageName, {
      path: location.pathname,
      search: location.search,
      hash: location.hash,
      timestamp: new Date().toISOString()
    });
  }, [location]);
}; 